import { jsx, jsxs } from "react/jsx-runtime";
import { Slot, Slottable } from "@radix-ui/react-slot";
import { cleanProps, cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { plainAVariants } from "./PlainA.variants.js";
const textStyleIconSizes = {
    body1: '24',
    body2: '20',
    body3: '16',
    heading4: '24',
    heading5: '20',
    heading6: '16'
};
function PlainA({ asChild, children, className, href, iconLeft, iconRight, slots = {
    buttonSlot: '',
    textSlot: '',
    iconSlot: ''
}, ...props }) {
    const { buttonSlot, textSlot, iconSlot } = plainAVariants(props);
    const classes = cn(buttonSlot(), className ?? slots.buttonSlot);
    const iconSlotClasses = cn(iconSlot(), slots.iconSlot);
    const textSlotClasses = cn(textSlot(), slots.textSlot);
    const iconSize = textStyleIconSizes[props.textStyle ?? 'body2'];
    const Comp = asChild ? Slot : 'a';
    return /*#__PURE__*/ jsx(Comp, {
        className: classes,
        href: href,
        ...cleanProps(props, [
            'type',
            'textStyle',
            'emphasis',
            'variant',
            'active'
        ]),
        children: /*#__PURE__*/ jsx(Slottable, {
            children: /*#__PURE__*/ jsxs("span", {
                className: "align-center inline-flex min-w-0 flex-row items-center justify-center gap-1",
                children: [
                    iconLeft && /*#__PURE__*/ jsx(CdnIcon, {
                        className: iconSlotClasses,
                        iconName: iconLeft,
                        size: iconSize,
                        title: 'string' == typeof children ? children : void 0
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: textSlotClasses,
                        children: children
                    }),
                    iconRight && /*#__PURE__*/ jsx(CdnIcon, {
                        className: iconSlotClasses,
                        iconName: iconRight,
                        size: iconSize,
                        title: 'string' == typeof children ? children : void 0
                    })
                ]
            })
        })
    });
}
export { PlainA };
